<template>
  <ipo3-page>
    <template slot="title">用戶列表</template>
    <template slot="tools">
      <el-input v-model="form.keyword" style="width:200px;margin-right:10px;" placeholder="請輸入電郵地址"></el-input>
      
      <el-date-picker
      v-model="form.date"
      type="daterange"
      range-separator="至"
      start-placeholder="開始日期"
      end-placeholder="結束日期" style="margin-right:10px;">
    </el-date-picker>
    <el-select v-model="form.status" placeholder="請選擇狀態" style="margin-right:10px;">
              <el-option
                v-for="item in statuses"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
    </el-select>
    <el-button icon="el-icon-edit" @click="getLists()" type="primary">搜索</el-button>

    </template>
    <template slot="page">
      <div class="page_view">
        <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="用户名称">
            <el-input v-model="formInline.name" placeholder="用户"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form> -->
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          
          <template v-for="item in items">
              <el-table-column
              :key="item.id"
              v-if="item.id === 'status'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <p
                v-if="scope.row.status == 1">正常</p>

                <el-popover
                  v-else-if="scope.row.status == 2"
                  placement="top-start"
                  :title="scope.row.user_delete.reason "
                  :width="280"
                  trigger="hover"
                  :content="scope.row.user_delete.recommendation+ '-' + scope.row.user_delete.create_time"
                >
                  <template #reference>
                    <el-button class="m-2">刪除</el-button>
                  </template>
                </el-popover>

                <p v-else>未激活</p>
              </template>
            </el-table-column>
            
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>

          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="success"
                  
                >删除</el-button>
                
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>

<script>
export default {
  name: "member-list",
  data() {
    return {
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      formInline: {
        name: ""
      },
      items: [
        { name: "編號", id: "id" },
        { name: "昵稱", id: "username" },
        { name: "郵箱", id: "email" },
        { name: "狀態", id: "status" },
        { name: "註冊時間", id: "create_time" }
      ],
      form:{
        keyword: '',
        status: 'all',
        date:'',
      },
      statuses:[
        {
          id: 'all',
          name: '全部'
        },
        {
          id: 1,
          name: '正常'
        },
        {
          id: 2,
          name:'刪除'
        }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  filters: {
    formatMoney(value) {
      var money = value / 100;
      return money.toFixed(2);
    }
  },
  created() {
    this.getLists();
  },
  methods: {
    onSubmit() {
      let params = Object.assign({},this.form);      
      if(params.date)
      {
        params.start = params.date[0].getTime()/1000;
        params.end = params.date[1].getTime()/1000;
      }else{
        params.start =0;
        params.end = 0;
      }
      params.page = 1;
      params.size = 10;
      params.name = this.formInline.name;
      var self = this;
      this.$http.get("/admin/member", params).then(res => {
        if (res.code == 200) {
          const { data, total, per_page } = res.data;
          self.pagecount = total;
          self.paginate = per_page;
          self.tableData = data;
          console.log("ddd:",self.tableData);
        }
      });
    },
    getLists(page = 1, size = 10) {
      let params = Object.assign({},this.form);
      if(params.date)
      {
        params.start = params.date[0].getTime()/1000;
        params.end = params.date[1].getTime()/1000;
      }else{
        params.start =0;
        params.end = 0;
      }
      params.page = page;
      params.size = size;
      var self = this;
      this.$http.get("/admin/member", params).then(res => {
        if (res.code == 200) {
          const { data, total, per_page } = res.data;
          self.pagecount = total;
          self.paginate = per_page;
          self.tableData = data;
        }
      });
    },
    onHandle(index, id) {
      this.$router.push(`/member/detail/${id}`);
    },
    handleSizeChange(val) {
      this.getLists(1, val);
    },
    handleCurrentChange(val) {
      this.getLists(val);
    },
    onDelete(index,value)
    {
      var self = this;
        this.$http.get("/admin/member/delete",{id:value.id}).then(res=>{
          if(res.code==200)
          {
              self.getLists();
          }
        })
    }
  }
};
</script>

